module.exports = __webpack_public_path__ + "4bcb34b8c0dde86b7153148da2f76e6d.png";